window.CaffeNeroEnrolment = (function($, util, components) {
    window.dataLayer = window.dataLayer || [];
    let self = {
        state: {
            yoyoAuthCodeUrl: ''
        },
        elements: {
            buttons: {
                guardedButtons: '.guarded-button',
                complianceButtons: '.compliance-button'
            },
            ids: {
                enrolForm: '#caffenero-enrol',
                refreshModal: 'nero-refresh-modal',
                successfulDelinkNotification: 'CAFFE_NERO_DE_LINK_COMPLETED'
            }
        },
        urls: {
            fetchAuthCode: '/api/sitecore/CaffeNeroEnrolment/FetchAuthCode',
            enrolMember: '/api/sitecore/CaffeNeroEnrolment/Enrol',
            errorPage: '/error/error-page'
        },
        func: {
            init: function() {
                self.func.bindings();
            },
            bindings: function() {
                $(components.ComplianceInformation.Elements.Buttons.SignUpButton)
                    .on('click', self.func.handleSignUpButtonClick);
                $(self.elements.buttons.openDelinkModalButton).on('click', self.func.pushOpenDelinkModalAnalytics);
            },
            handleSignUpButtonClick: function() {
                if (components.ComplianceInformation.Func.IsSignUpButtonEnabled()) {
                    self.func.fetchAuthCode();
                    window.dataLayer.push({
                        event: self.gtm.event.ctaClick,
                        clickValue: self.gtm.clickValue.link
                    });
                    components.ComplianceInformation.Func.SwitchToPleaseWaitButton();
                }
            },
            fetchAuthCode: function() {
                util.func.callWebApi({
                    type: 'GET',
                    url: self.urls.fetchAuthCode
                }).then(self.func.fetchAuthCodeSuccess, self.func.handleError);
            },
            fetchAuthCodeSuccess: function(data) {
                self.state.yoyoAuthCodeUrl = data.yoyoAuthCodeUrl;
                window.dataLayer.push({
                    event: self.gtm.event.ctaClick,
                    clickValue: self.gtm.clickValue.activate
                });
                components.ComplianceInformation.Func.SwitchToRefreshButton();
                self.func.redirectToYoyo();
            },
            redirectToYoyo: function() {
                util.func.redirect(self.state.yoyoAuthCodeUrl);
            },
            redirectToErrorPage: function() {
                util.func.redirect(self.urls.errorPage);
            },
            enrolMember: function() {
                let url = new URL(location.href);
                let data = {
                    landingPageId: $('#landing-page-data').data('landing-page-guid'),
                    code: url.searchParams.get('code'),
                    state: url.searchParams.get('state'),
                    error: url.searchParams.get('error')
                };
                util.func.callWebApi({
                    method: 'post',
                    url: self.urls.enrolMember,
                    data: data
                }).then(self.func.enrolMemberSuccess, self.func.handleError);
            },
            enrolMemberSuccess: function(data) {
                if (data.notificationCode == null) {
                    util.func.redirect(data.redirect);
                } else {
                    util.func.redirect(data.redirect, { notificationCode: data.notificationCode });
                }
            },
            handleError: function(jqxhr) {
                if (jqxhr.statusCode === util.httpStatusCodes.loginTimeout) {
                    util.func.reloadPage();
                } else {
                    self.func.redirectToErrorPage();
                }
            },
            pushOpenDelinkModalAnalytics: function() {
                window.dataLayer.push({
                    event: self.gtm.event.delink,
                    action: self.gtm.action.delinkAccount,
                    partner: self.gtm.partner.caffeNero
                });
            },
            pushDelinkAnalytics: function(notificationCode) {
                let eventObject = {
                    action: self.gtm.action.delinkAccount,
                    partner: self.gtm.partner.caffeNero
                };

                if (notificationCode === self.elements.ids.successfulDelinkNotification) {
                    eventObject.delinkResult = self.gtm.delinkResult.successful;
                } else {
                    eventObject.delinkResult = self.gtm.delinkResult.failure;
                    eventObject.errorMessage = notificationCode;
                }

                window.dataLayer.push(eventObject);
            }
        },
        gtm: {
            event: {
                ctaClick: 'ctaClick',
                delink: 'delink'
            },
            clickValue: {
                link: 'link-account',
                activate: 'activate'
            },
            action: {
                delinkAccount: 'delinkAccount'
            },
            partner: {
                caffeNero: 'caffeNero'
            },
            delinkResult: {
                successful: 'successful',
                failure: 'failure'
            }
        }
    };

    return {
        init: self.func.init,
        enrolMember: self.func.enrolMember,
        pushDelinkAnalytics: self.func.pushDelinkAnalytics
    };
})
(jQuery, window.Utilities, { ComplianceInformation: window.ComplianceInformation });

$('document').ready(function () {
    let util = window.Utilities;

    let getParameterByName = function(name) {
        const valueIndex = 2;
        let url = window.location.href;
        let updatedName = name.replace(/[\[\]]/g, '\\$&');
        let regex = new RegExp('[?&]' + updatedName + '(=([^&#]*)|&|#|$)');
        let results = regex.exec(url);
        if (!results) {
            return null;
        }
        if (!results[valueIndex]) {
            return '';
        }
        return decodeURIComponent(results[valueIndex].replace(/\+/g, ' '));
    };

    let pageData = $('#page-data');
    let inCaffeNeroFeature = 'CaffeNero' === pageData.data('feature');
    let onPendingPage = 'pending' === pageData.data('page');
    let afterDelinkAction = 'delink' === getParameterByName('action');
    let normalPageMode = 'normal' === pageData.data('page-mode');

    if (util.func.isPartnerPageWithName('CaffeNero')) {
        window.CaffeNeroEnrolment.init();

        if (afterDelinkAction) {
            window.CaffeNeroEnrolment.pushDelinkAnalytics(getParameterByName('notificationCode'));
        }
    }

    if (inCaffeNeroFeature && onPendingPage && normalPageMode) {
        window.CaffeNeroEnrolment.enrolMember();
    }
});
